import { put, takeEvery, all } from 'redux-saga/effects';
import { Log } from 'ng2-logger';
import * as constants from '../constants/files';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import { FileService } from '../../api/file-service';
import * as myFilesActions from '../actions/files'; 

const T = Translator.create();
const _logger = Log.create('files_sagas');
const fileService = new FileService()

function* getMyFiles(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield fileService.RequestGetMyFilesAsync(params.parameters)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        if (!isError) {
            yield put(myFilesActions.SetMyFilesAction(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
            if(params.callback){
                params.callback();
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* addMyFiles(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield fileService.RequestAddMyFilesAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
            });
        if (!isError) {
            Notification.setNotification('success', T.t("r_api_send_assignment_success"), 'topRight');
            if(params.callback){
                params.callback();
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetMyFiles() {
    yield takeEvery(constants.actions.GET_MY_FILES, getMyFiles);
    return null;
}

export function* watchAddMyFiles() {
    yield takeEvery(constants.actions.ADD_MY_FILES, addMyFiles);
    return null;
}

export function* MyFilesSagas() {
    yield all([
        watchGetMyFiles(),
        watchAddMyFiles(),
    ]);
}